import NavbarLogin from "../../../components/nav/nav_login";
import PrivacyPolicyContent from "../../privacy_policy_page_content";
import "./privacy_page.css";
import { useNavigate } from "react-router-dom";

const PrivacyPage =  () =>{

    const navigate = useNavigate();

    const navigateToTerms = () => {
        navigate("/terms_of_service");
    }

    const navigateToPrivacy = () =>{
        navigate("/privacy_policy");
    }

    const navigateToHome = () =>{
        navigate("/");
    }


    return(
        <div className="legal-page-whole-outer" style={{width:'100%'}}>
                <div className="legal-page-whole">
                    <NavbarLogin/>
                    <PrivacyPolicyContent></PrivacyPolicyContent>
                </div>
                {<div className="footer-container">
                    <p onClick={navigateToHome} className="footer-brand">Stock Archives LLC</p>
                    <p onClick={navigateToTerms}  className="footer-other-right">Terms Of Use</p>
                    <p onClick={navigateToPrivacy} className="footer-other-left">Privacy Policy</p>
                </div>}
        </div>
    );
}

export default PrivacyPage;